import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const adminApi = axios.create({
  baseURL: BASE ? `${BASE}/api` : undefined,
  withCredentials: true,
  timeout: 20000,
});

adminApi.interceptors.response.use(undefined, async (error) => {
  const original = error.config;
  const url = original?.url || "";
  if (error.response?.status === 401 && original && !original._retry && !url.startsWith("/auth/")) {
    original._retry = true;
    await adminApi.post("/auth/refresh");
    return adminApi(original);
  }
  return Promise.reject(error);
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}
